module.exports = "<div>\n    <div>\n        <p>\n            Reason:\n        </p>\n        <p>\n            Status:\n        </p>\n    </div>\n</div>"